import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { romeNyConfig } from "./data";

export default function RomeNYPage() {
  return <CityPageTemplate config={romeNyConfig} />;
}